import styled from 'styled-components';
import Base from "./Base";

import THEME_CONSTS from '~/consts/theme';

const ButtonDanger = styled(Base)`
    color: ${THEME_CONSTS.BUTTON_DANGER_FONT_COLOR};
    background-color: ${THEME_CONSTS.BUTTON_DANGER_BG_COLOR};
    border: 1px solid ${THEME_CONSTS.BUTTON_DANGER_BG_COLOR};
`;

export default ButtonDanger;